<template>
  <div
    v-tooltip="eventTooltip"
    class="month-event"
    :class="{ 'a-tooltip': showImportedTimeOffBadge }"
    :aria-label="bambooHrEventAriaLabel"
    :style="defaultStyle"
    :data-testid="showImportedTimeOffBadge ? 'schedules-time-off-event' : null"
  >
    <div class="d-flex justify-content-between">
      <div class="d-flex flex-column">
        <div class="name d-flex align-items-center min-w-0">
          <span class="text-truncate">{{ userRealName }}</span>
        </div>
        <div class="event-details d-flex align-items-center min-w-0">
          <span class="text-truncate">{{ eventDetails }}</span>
          <TimeOffRequestBambooHrBadge
            v-if="showImportedTimeOffBadge"
            class="ml-5"
          />
        </div>
      </div>

      <div
        v-if="shiftSpillover"
        class="d-flex align-items-center"
      >
        <i
          v-tooltip="{ placement: 'top' }"
          class="hi-right"
          title="This shift continues into the next day"
        />
      </div>
    </div>
  </div>
</template>

<script>
import SchedulesEventMixin from '~/mixins/attendance_schedules/SchedulesEventMixin';
import TimeOffRequestBambooHrBadge from '~/components/time_off/TimeOffRequestBambooHrBadge.vue';
import { mapInertiaProps } from '~/utils/inertia';

export default {
  name: 'MonthViewEvent',
  components: { TimeOffRequestBambooHrBadge },
  mixins: [SchedulesEventMixin],
  props: {
    event: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapInertiaProps({
      timeZone: ({ time_zone: timeZone }) => timeZone.for,
    }),
    eventDetails() {
      return this.type !== 'Holiday' ? `${this.type}: ${this.duration}` : this.type;
    },
  },
};
</script>
